import type { OnChanges } from '@angular/core';
import { Directive, inject, Input, ElementRef } from '@angular/core';
import JsBarcode from 'jsbarcode';

@Directive({
  selector: '[appBarcode]',
})
export class BarcodeDirective implements OnChanges {
  el = inject(ElementRef);

  @Input('appBarcode') value!: string;

  ngOnChanges(): void {
    if (this.value) {
      const SVG: SVGElement = this.el.nativeElement;
      SVG.setAttribute('width', '100%');
      SVG.setAttribute('height', '60');
      JsBarcode(SVG, this.value, {
        format: 'CODE128',
        lineColor: '#000',
        width: 4, // width of a single bar
        height: 80,
        displayValue: false,
      });
    }
  }
}
